import React from 'react';
import { Modal } from 'antd';
import UserForm from './UserForm';
import { useGeneralStore } from '../../store/slices/createGeneralSlice';
import { usePersistedStore } from '../../store/persisted-store';

export default function EditUser({ pageNumber, pageSize }) {
    const { users } = usePersistedStore()
    const general = useGeneralStore();
    const user = users.single;
    const visible = general.view.userEditModal;

    return (
        <Modal
            width={800}
            className="custom-table"
            title="بروزرسانی اطلاعات کاربر"
            visible={visible}
            footer={false}
            onCancel={() => general.ToggleEditUserModal()}>
            <UserForm
                onSubmit={() => {
                    general.ToggleEditUserModal();
                    general.NotifSuccess('اطلاعات کاربر با موفقیت بروزرسانی شد');
                }}
                user={user}
                formType={true}
                pageNumber={pageNumber}
                pageSize={pageSize}
            />
        </Modal>
    )
}
